import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../widgets/tables/Table';
import WaitDialog from '../../widgets/WaitDialog';
import { NineCellLoading } from 'react-loadingg';

import getCorsiEliminati from '../../services/getCorsiEliminati';
import DeleteCorso from '../../services/deleteCorso';
import updateCorsoStatus from '../../services/updateCorsoStatus';
import translateString from "../../utils/Locales";

let t = translateString;

export default class CorsiEliminati extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: []
    }

    this.grid = 2;

    this.pdfElements = [];

    this.corsi = [];
    this.brokerId = undefined;

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });

    this.state = {
      isLoading: true,
    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.corsi = await getCorsiEliminati(username, token);

    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();
  }


  render () {

    const cookies = new Cookies();

    var headCells = [
   //   { id: '__', numeric: false, disablePadding: true, label: '' },
      { id: 'name', numeric: false, disablePadding: true, label: t('nome') },
      { id: 'dateStart', numeric: true, disablePadding: false, label: t('data_inizio') },
      { id: 'dateEnd', numeric: true, disablePadding: false, label: t('data_fine') },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    this.searchCols = ['name'];
    
    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('cestino')} />
        <div style={{ display: 'flex', marginTop: -30, marginBottom: 10, marginLeft: 5 }}>
                <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('corsi_eliminati')}</p><br/>
          </div>

        <Table headCells={headCells} searchCols={this.searchCols} rows={this.corsi} 
          onEventClick={(row) => {
          cookies.set('currentCourse', row, { path: '/' });
          window.location.href =  '/' + this.dbPath + '/#/app/editCorso';
        }}

        onCalendarClick={(id) => {
          cookies.set('currentCourse', id, { path: '/' });
          window.location.href= this.dbPath + '/#/app/schedule';
        }}

        onPdfClicked={elem => {
          const cookies = new Cookies();
          cookies.set('currentCorso', elem, { path: '/' });
          window.location.href= this.dbPath + '/#/app/pdfCorsoPage';

        }}

        onDelete={async (id) => {
          if (window.confirm(t('elimina_corso')) == false) return;

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          await DeleteCorso(username, token, id);
          this.reload();
        }}

        onRestore={async (id) => {
          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          await updateCorsoStatus(username, token, id, 1);

          this.reload();
        }}

        onElementCheck={async (companyId) => {
          const cookies = new Cookies();

          var json = cookies.get('checksList', { path: '/' });
          var checksList = json.list;
          var index = checksList.indexOf(companyId);
          if (index != -1)
            checksList.splice(index, 1);
          else 
            checksList.push(companyId);

          cookies.set('checksList', JSON.stringify({list: checksList}), { path: '/' });
        }}

        />

        {this.elementPdf ? this.elementPdf : null}
        

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </>
    );
  }
}

